import React from "react"
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import './footer.css'

const Footer = () => {

    const footerImages = useStaticQuery(graphql`
    query {
        batch1F10: file(relativePath: { eq: "Batch_1_Singapore_Emblem.png" }) {
        childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid
            }
        }
        },
        f10Logo: file(relativePath: { eq: "f10_logo.png" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 100) {
                ...GatsbyImageSharpFluid
                }
            }
        },
        sgFintechNewsLogo: file(relativePath: { eq: "singapore-fintechnews.png" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 100) {
                ...GatsbyImageSharpFluid
                }
            }
        },
        sfaLogo: file(relativePath: { eq: "SFA_logo.png" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 100) {
                ...GatsbyImageSharpFluid
                }
            }
        },
    }
    `)


    return (
        <footer id="footer" class="footer">
            <div class="footer container">
                <div class="row p-0">
                    <div class="col-lg-4 text-center">
                        <div className="small-font">Maesh got selected into the first cohort of</div>
                        <div className="small-font"><a
                            href="https://www.f10.ch/pressreleases/these-are-the-startups-accepted-into-the-f10-incubation-program-in-singapore/"><strong>
                                F10 Fintech Incubator & Accelerator</strong></a> in Singapore:</div>
                        <div className="f10-news">
                            <div>
                            <a
                                href="https://www.f10.ch/pressreleases/these-are-the-startups-accepted-into-the-f10-incubation-program-in-singapore/">
                                <Img
                                    fluid={footerImages.batch1F10.childImageSharp.fluid}
                                    alt="Batch I Singapore Incubation Program 2020 F10"
                                    className="big-footer-logo" />
                            </a>
                            </div>
                            <div>
                            <a href="https://www.f10.ch/" target="_blank" rel="noreferrer"><Img fluid={footerImages.f10Logo.childImageSharp.fluid}
                                alt="F10 Fintech Incubator & Accelerator" className="small-footer-logo" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 text-center footer-featured-on">
                        <p className="small-font">As featured on:</p>
                        <a
                            href="https://fintechnews.sg/38722/fintech/10-fintech-startups-accepted-into-first-f10-incubation-program-in-singapore/"><Img
                            fluid={footerImages.sgFintechNewsLogo.childImageSharp.fluid} alt="Singapore Fintech News featuring Maesh" className="small-footer-logo" /></a>
                    </div>
                    <div class="col-lg-4 text-center">
                        <p className="small-font">Maesh is <a target="blank"
                            href="/Maesh_SFA_FinTech_Certificate.pdf" rel="noreferrer"><strong>FinTech certified</strong></a> and
						member of the Singapore Fintech Association:</p>
                        <a href="https://singaporefintech.org/" target="_blank" rel="noreferrer"><Img fluid={footerImages.sfaLogo.childImageSharp.fluid}
                            alt="Singapore Fintech Association Logo" className="small-footer-logo" /></a>
                    </div>
                </div>
                <div class="row p-0 mt-2">
                    <div class="col-lg-12 text-center">
                        <p><strong>© Maesh {(new Date().getFullYear())} </strong> - Online PayNow payment gateway<br /><span class="small">Maesh Pte. Ltd.
							(201936523Z)</span></p>
                        <p><strong>Made with <span role="img" aria-label="love">❤️</span> in Singapore</strong></p>
                        <p><span class="small">Contact us at <a target="_blank" rel="noreferrer" href="mailto:hello@maesh.io">hello@maesh.io</a></span></p>
                    </div>
                </div>
                <div class="row p-0">
                    <div className="col-lg-6 text-center">
                        <p className="small"><strong>Regular Business Hours </strong></p>
                        <p className="small">
                        Monday to Friday, 8AM to 6PM (Excluding Holidays)
                        </p>
                    </div>
                    <div className="col-lg-6 text-center">
                        <p className="small"><strong>Registered Address / Office</strong></p>
                            <p className="small">
                            1 Raffles Place, #34-04, Singapore 048616
                            </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <p className="small-font">
                            View our  <a
                                href="https://maesh.io/docs/servicesAgreement" target="_blank" rel="noreferrer">services agreement</a>
                        </p>
                        <p className="small-font">Maesh Pte. Ltd. has been granted <a
                            href="https://www.mas.gov.sg/regulation/payments/entities-that-have-notified-mas-pursuant-to-the-ps-esp-r" target="_blank" rel="noreferrer">an
                            exemption by the Monetary Authority Singapore (MAS)</a> from holding a license under the
                        Payment Services Act for providing Merchant Acquisition Services until January 28, 2021.
                        Maesh Pte. Ltd. is allowed to continue to provide such services pursuant to the Payment
                        Services (Exemption for Specified Period) Regulations 2019.</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
